import { combineReducers } from 'redux';
import { applicationSavePrivacyPolicyReducer } from './savePrivacyPolicy';
import { applicationSaveUserConsentReducer } from './saveUserConsent';
import { applicationUpdateGoogPalNonceReducer } from './googPalNonce';

export const applicationInternalReducer = combineReducers({
  consentSettings: applicationSaveUserConsentReducer,
  hidePrivacyNotification: applicationSavePrivacyPolicyReducer,
  googPalNonce: applicationUpdateGoogPalNonceReducer,
});
